import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SelectButtonChangeEvent } from 'primeng/selectbutton';

/** Titre d'accroche, description de la prestation de pose et sélection de l'ancienneté du logement. */
@Component({
  selector: 'ng-casto-pose-description',
  templateUrl: './pose-description.component.html',
  styleUrls: ['./pose-description.component.scss'],
})
export class PoseDescriptionComponent {
  /** Titre d'accroche (HTML autorisé). */
  @Input() title: string;
  /** Description de la prestation (HTML autorisé). */
  @Input() description: string;
  /** Libellé de la question sur l'ancienneté du logement (HTML autorisé). */
  @Input() moreThan2YearsLabel: string;
  /** Désactive la sélection de l'ancienneté du logement. */
  @Input() disabled: boolean;
  /** Émet la nouvelle valeur d'ancienneté du logement. */
  @Output() moreThan2YearsChange = new EventEmitter<boolean>();

  protected readonly options = [
    { label: 'yes', value: true },
    { label: 'no', value: false },
  ];

  protected value: boolean;
  private lastValue: boolean;

  /** Ancienneté du logement : plus de 2 ans (oui) ou non. */
  @Input() set moreThan2Years(value: boolean) {
    this.value = value;
    this.lastValue = value;
  }

  /** Émet le changement d'ancienneté, ou restaure la dernière valeur lorsque la sélection est annulée. */
  protected handleOnSelectButtonChange(event: SelectButtonChangeEvent): void {
    if (event.value === null || event.value === undefined) {
      setTimeout(() => {
        this.value = this.lastValue;
      });
    } else {
      this.lastValue = event.value;
      this.moreThan2YearsChange.emit(event.value);
    }
  }
}
